import {
  DatatablesFooter,
  IconButtonDatatable,
  InputTextMaster,
  MasterButton,
  SearchInput,
  TableHeader,
} from "App/Component/ui";
import {
  Grid,
  TableRow,
  Table,
  TableContainer,
  TableBody,
  Paper,
} from "@material-ui/core";
import { useDatatables } from "App/hooks";
import { TableCell } from "@material-ui/core";
import { stableSort, getComparator } from "App/Component/ui/datatable/utils";
import { SelectIcon } from "App/Assets";
import { defaultDateDisplay } from "App/utils/helpers";
import { headCellsListSEP } from "./helpers";
import { useSearchHistorySep } from "../ModalSEP/hooks";
import React from "react";

export const TableListNoSEP = ({ noBpjs, handleClickSelect }) => {
  const { disabled, handleChange, handleSubmit, filter, rows } =
    useSearchHistorySep(noBpjs);

  return (
    <Paper
      className='show-element'
      style={{
        padding: "1rem",
      }}>
      <Grid container spacing={3}>
        <Grid item sm={4}>
          <InputTextMaster
            name='no_bpjs'
            label='NO BPJS'
            id='no_bpjs'
            value={filter.no_bpjs}
            placeholder={"No BPJS"}
            onChange={handleChange("no_bpjs")}
          />
        </Grid>
        <Grid item sm={4}>
          <InputTextMaster
            name='valid_from'
            label='TANGGAL MULAI'
            id='valid_from'
            type='date'
            autoFocus={true}
            value={filter.valid_from}
            onChange={handleChange("valid_from")}
          />
        </Grid>
        <Grid item sm={4}>
          <InputTextMaster
            name='valid_to'
            label='TANGGAL SELESAI'
            id='valid_to'
            type='date'
            autoFocus={true}
            value={filter.valid_to}
            onChange={handleChange("valid_to")}
          />
        </Grid>
      </Grid>
      <Grid
        container
        direction='row'
        justifyContent='flex-end'
        alignItems='center'>
        <MasterButton
          className={"mt-1"}
          type='button'
          onClick={(e) => handleSubmit(e)}
          color={disabled.color}
          name={disabled.label}
          size='md'
        />
      </Grid>

      <TableListSEP rows={rows} handleClickSelect={handleClickSelect} />
    </Paper>
  );
};

export const TableListSEP = ({ rows, handleClickSelect }) => {
  const {
    page,
    setPage,
    setRowsPerPage,
    order,
    orderBy,
    length,
    handleRequestSort,
    rowsPerPage,
    setQ,
    data,
  } = useDatatables({
    rows: rows,
    orderByDefault: "namaPeserta",
    orderByRow: [
      "namaPeserta",
      "kelasRawat",
      "noKartu",
      "noRujukan",
      "noSep",
      "tglSep",
      "ppkPelayanan",
      "poli",
    ],
  });

  return (
    <>
      <TableContainer
        className='custom-scrollbar '
        style={{
          maxHeight: "400px",
        }}>
        <div
          className=''
          style={{
            margin: "1rem 0",
          }}>
          <SearchInput withIcon={true} onchange={(e) => setQ(e.target.value)} />
        </div>
        <Table
          aria-labelledby='tableTitle'
          size={"medium"}
          aria-label='enhanced table'>
          <TableHeader
            order={order}
            orderBy={orderBy}
            onRequestSort={handleRequestSort}
            headCells={headCellsListSEP}
          />

          <TableBody>
            {stableSort(data, getComparator(order, orderBy))
              .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
              .map((row, index) => {
                return (
                  <TableRow
                    hover
                    tabIndex={-1}
                    key={row.name}
                    style={{
                      backgroundColor: index % 2 === 0 ? "transparent" : "#fff",
                    }}>
                    <TableCell
                      component='th'
                      scope='row'
                      padding='none'
                      align='center'>
                      {index + 1}
                    </TableCell>

                    <TableCell
                      component='th'
                      scope='row'
                      width='5%'
                      padding='none'
                      align='center'>
                      <IconButtonDatatable
                        color='secondary'
                        aria-label='delete'
                        onClick={() => handleClickSelect(row)}
                        style={{
                          background: "#D8D8D8",
                          borderRadius: "8px",
                          padding: "6px",
                        }}>
                        <SelectIcon width={"12"} height={"14"} fill={"#fff"} />
                      </IconButtonDatatable>
                    </TableCell>
                    <TableCell>{row?.namaPeserta}</TableCell>
                    <TableCell>
                      {defaultDateDisplay(row?.tglSep, false)}
                    </TableCell>
                    <TableCell>{row?.poli}</TableCell>
                    <TableCell>{row?.kelasRawat}</TableCell>
                    <TableCell>{row?.noKartu}</TableCell>
                    <TableCell>{row?.noRujukan}</TableCell>
                    <TableCell>{row?.noSep}</TableCell>
                    <TableCell>{row?.ppkPelayanan}</TableCell>
                  </TableRow>
                );
              })}
            {length === 0 && (
              <TableRow>
                <TableCell align='center' colSpan={headCellsListSEP.length}>
                  Tidak ada data
                </TableCell>
              </TableRow>
            )}
          </TableBody>
        </Table>
      </TableContainer>
      <DatatablesFooter
        page={page}
        length={length}
        rowsPerPage={rowsPerPage}
        selectRows={[10, 20]}
        onPageChange={(page) => setPage(page - 1)}
        onSelectChange={(e) => setRowsPerPage(e.target.value)}
      />
    </>
  );
};

export default TableListNoSEP;
